import { AttributeFormView } from "@/modules/dynamic-attributes/entities/attribute";
import {
  useSaveAttribute,
  FieldsType,
} from "@/modules/dynamic-attributes/entities/attribute";
import { getInitialLocalizedValueInput } from "@/shared/form/localized-value";
import { useAttributeCodeInUseValidation } from "./utils/validation";
import { DynamicAttributeEntity } from "gql/graphql";

export type AttributeFormProps = {
  afterSubmit?: () => void;
  groupId?: string;
  dynamicAttributeEntity: DynamicAttributeEntity;
  entity?: FieldsType;
  category?: string;
};

export function AttributeForm({
  afterSubmit,
  dynamicAttributeEntity,
  groupId,
  entity,
  category,
}: AttributeFormProps) {
  const { save } = useSaveAttribute({ afterSubmit, entity });
  const { attributeCodeInUseValidator } = useAttributeCodeInUseValidation({
    entity,
  });

  return (
    <AttributeFormView
      onFinish={save}
      initialValues={
        entity ??
        ({
          description: getInitialLocalizedValueInput(),
          group: groupId,
          dynamicAttributeEntity,
          category,
        } as FieldsType)
      }
      attributeCodeInUseValidator={attributeCodeInUseValidator}
    />
  );
}
